/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllPalReauthSubmissionsResponse } from './FindAllPalReauthSubmissionsResponse';
import {
    FindAllPalReauthSubmissionsResponseFromJSON,
    FindAllPalReauthSubmissionsResponseFromJSONTyped,
    FindAllPalReauthSubmissionsResponseToJSON,
} from './FindAllPalReauthSubmissionsResponse';

/**
 * 
 * @export
 * @interface FindAllPalReauthSubmissions200Response
 */
export interface FindAllPalReauthSubmissions200Response {
    /**
     * 
     * @type {FindAllPalReauthSubmissionsResponse}
     * @memberof FindAllPalReauthSubmissions200Response
     */
    data?: FindAllPalReauthSubmissionsResponse;
}

/**
 * Check if a given object implements the FindAllPalReauthSubmissions200Response interface.
 */
export function instanceOfFindAllPalReauthSubmissions200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPalReauthSubmissions200ResponseFromJSON(json: any): FindAllPalReauthSubmissions200Response {
    return FindAllPalReauthSubmissions200ResponseFromJSONTyped(json, false);
}

export function FindAllPalReauthSubmissions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalReauthSubmissions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllPalReauthSubmissionsResponseFromJSON(json['data']),
    };
}

export function FindAllPalReauthSubmissions200ResponseToJSON(value?: FindAllPalReauthSubmissions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllPalReauthSubmissionsResponseToJSON(value.data),
    };
}

